export const priceValues = [
  { key: 0, display: '£0' },
  { key: 1000, display: '£1,000' },
  { key: 2000, display: '£2,000' },
  { key: 3000, display: '£3,000' },
  { key: 4000, display: '£4,000' },
  { key: 5000, display: '£5,000' },
  { key: 6000, display: '£6,000' },
  { key: 7000, display: '£7,000' },
  { key: 8000, display: '£8,000' },
  { key: 9000, display: '£9,000' },
  { key: 10000, display: '£10,000' },
  { key: 11000, display: '£11,000' },
  { key: 12000, display: '£12,000' },
  { key: 13000, display: '£13,000' },
  { key: 14000, display: '£14,000' },
  { key: 15000, display: '£15,000' },
  { key: 16000, display: '£16,000' },
  { key: 18000, display: '£18,000' },
  { key: 20000, display: '£20,000' },
  { key: 25000, display: '£25,000' },
  { key: 30000, display: '£30,000' },
  { key: 40000, display: '£40,000' },
  { key: 50000, display: '£50,000' },
  { key: 75000, display: '£75,000' },
  { key: 100000, display: '£100,000' },
  { key: 250000, display: '£250,000' },
  { key: 500000, display: '£500,000' },
  { key: 1000000, display: '£1,000,000' },
  { key: 2000000, display: '£2,000,000' },
  { key: 3000000, display: '£3,000,000' }
];

export const withinDistanceValues = [
  { key: '10 miles' },
  { key: '20 miles' },
  { key: '30 miles' },
  { key: '40 miles' },
  { key: '60 miles' },
  { key: '80 miles' },
  { key: '100 miles' },
  { key: '150 miles' },
  { key: '200 miles' },
  { key: 'Over 200 miles' }
];

export const topEightCarTypes = [
  { key: 'hatchback' },
  { key: 'suv' },
  { key: 'saloon' },
  { key: 'coupe' },
  { key: 'estate' },
  { key: 'sports' },
  { key: 'mpv' },
  { key: 'convertible' }
];

export const sortByValues = [
  { key: 'asc', sortBy: 'cashPrice', sort: 'asc', display: 'Price (lowest)' },
  {
    key: 'desc',
    sortBy: 'cashPrice',
    sort: 'desc',
    display: 'Price (highest)'
  },
  { key: 'distance', sortBy: 'distance', sort: 'asc', display: 'Distance' },
  { key: 'mileage', sortBy: 'mileage', sort: 'asc', display: 'Mileage' },
  { key: 'newest', sortBy: 'year', sort: 'desc', display: 'Age (newest)' }
];



// WEBPACK FOOTER //
// ./src/Common/filterValues/index.js